export const Application = Object.freeze({
    stage:
        {
            view: 'Application.stage.view',
            edit: 'Application.stage.edit',
            payed: 'Application.stage.payed',
            empty: 'Application.stage.empty',
            success: 'Application.stage.success',
            undefined: 'Application.stage.undefined',
        },
    mode:
        {
            view: 'Application.mode.view',
            edit: 'Application.mode.edit'
        }
});